import React from 'react';
import { ShieldCheck } from 'lucide-react';
interface HeroProps {
  onScrollToPrice: () => void;
}
export function Hero({
  onScrollToPrice
}: HeroProps) {
  return <section className="bg-white pt-12 pb-16 md:pt-20 md:pb-24 px-4 text-center" data-id="element-137">
      <div className="max-w-3xl mx-auto" data-id="element-138">
        {/* Brand Title */}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-gray-900 tracking-tight mb-3" data-id="element-139">
          CRIANZA SIN <span className="text-red-600" data-id="element-140">CELULAR</span>
        </h2>

        {/* Headline */}
        <h1 className="text-lg md:text-xl lg:text-2xl font-bold text-gray-700 leading-snug mb-6" data-id="element-141">
          El celular no calma a tu hijo. <br className="hidden md:block" data-id="element-142" />
          <span className="text-red-600" data-id="element-143">Lo está condicionando.</span>
        </h1>

        {/* Subheadline */}
        <p className="text-sm md:text-base text-gray-500 mb-8 max-w-2xl mx-auto leading-relaxed font-medium" data-id="element-144">
          Una guía práctica para poner límites sin gritos, sin culpa y sin
          peleas diarias.
        </p>

        {/* Product Image */}
        <div className="relative mx-auto max-w-[400px] mb-10 cursor-pointer hover:opacity-95 transition-opacity" onClick={onScrollToPrice} data-id="element-145">
          <img src="https://cdn.magicpatterns.com/uploads/1GPopg84LWSHD2F5Ug43t5/ChatGPT_Image_5_feb_2026,_06_31_36_p.m..png" alt="Crianza Sin Celular - Saga completa de 5 tomos" className="w-full h-auto drop-shadow-xl rounded-xl" data-id="element-146" />
        </div>

        {/* CTA Button */}
        <button onClick={onScrollToPrice} className="w-full md:w-auto bg-red-600 hover:bg-red-700 text-white text-lg md:text-xl font-bold py-4 px-8 rounded-xl shadow-lg hover:shadow-xl hover:-translate-y-0.5 transition-all mb-4" data-id="element-147">
          Quiero recuperar mi lugar como adulto
        </button>

        {/* Micro Social Proof */}
        <p className="text-sm text-gray-500 font-medium mb-6" data-id="element-148">
          ⭐⭐⭐⭐⭐ Más de 200 familias ya lo aplican
        </p>

        {/* Guarantee Badge */}
        <div className="flex items-center justify-center gap-2 text-xs md:text-sm text-gray-400 font-medium" data-id="element-149">
          <ShieldCheck className="w-4 h-4 text-gray-400" data-id="element-150" />
          <span data-id="element-151">7 días de garantía de satisfacción</span>
        </div>
      </div>
    </section>;
}